export enum PaginatorIntervalTypeEnum {
  MONTH = 'MONTH',
  WEEK = 'WEEK',
}
